import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { configurationProfileFeatureKey, configurationProfileReducer } from './configuration-profile.reducer';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ConfigurationProfileEffects } from './configuration-profile.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(configurationProfileFeatureKey, configurationProfileReducer),
    EffectsModule.forFeature([ConfigurationProfileEffects]),
  ],
  providers: [],
})
export class ConfigurationProfileStoreModule {}
